import {SaveButton} from '@/components/refinedev/action_buttons';
import RoleForm from './role-form';
import CreateForm from '@/components/refinedev/pages/create-form';

const RoleCreate = () => {
  return (
    <CreateForm transformBeforeSave={RoleForm.transformBeforeSave}>
      <div className="max-w-xl mx-auto flex flex-col gap-y-4 ">
        <RoleForm />
        <SaveButton size="lg" className="self-end" />
      </div>
    </CreateForm>
  );
};

export default RoleCreate;
